// const BASE_URL = "http://localhost:3001";
// const BASE_URL = "http://api.uniteddisposal.trangotechdevs.com:3037";
const BASE_URL = "https://api.uniteddisposal.trangotechdevs.com";

const API_URL = BASE_URL + "/api/admin/";

const INITIAL_TOKEN = "313f8033-74b7-47d1-b137-8999922ef759";

export { API_URL, BASE_URL, INITIAL_TOKEN };
